<template>
    <div>

        <div class="bs1frame">
         
            <div class="bs1static">
                <el-row >
                    <el-col :span="10">体检地点</el-col>
                     <el-col :span="10">{{this.institution === '1' ? '东环分院' : '西环分院'}}</el-col>
                    
                </el-row>
                <el-row >
                   <el-col :span="10">体检日期</el-col>
                    <el-col :span="10">{{this.bkdate.date}}</el-col>
                </el-row>
            </div>
   
            
            <div class="bs1input" style="padding-top: 18px;">
                <span class="bs1label">身份证号：</span>
                <span class="bs1label">{{this.user.PaperValue}}</span>
                
            </div>
            <div class="bs1input">
                <span class="bs1label">手机号码：</span>
                <span class="bs1label">{{this.user.phone}}</span>
            </div>
               <div class="bs1input">
                <span class="bs1label">体检时段</span>
                <el-select id="inputpd" v-model="timeseg" value-key="PeriodID" placeholder="请选择体检时段">
                    <el-option-group >
                        <el-option v-for="item in periods" :key="item.PeriodID" :label="item.PeriodName" :disabled="item.isOrder!='True'"
                                   :value="item"></el-option>
                    </el-option-group>
                </el-select>
               <br> <span class="bs1input" style="color:red;padding-left:85px">请按时段到达</span>
            </div>
            <div style="height:20px;text-align:left;margin-top:12px;font-size:14px;color:#f55;">{{tips}}</div>
            <div style="text-align: center;margin-top: 18px;">
                <el-button type="primary" :loading="submitloading" @click="bookQuestion()">提交预约</el-button>
            </div>
                 
        </div>
        <div class="bfframe"  v-show="showtable">
            <div style="text-align:center;color:#20a0ff;font-size:1.5em;margin-top:40px;">
              <i class="el-icon-check"></i>{{this.bkfinaltext}}
            </div>
         
        </div>
   
    </div>
</template>
<script>

    import {foowwLocalStorage} from '../rest';
    import {restbase2} from '../rest'
    export default {
       data() {
            return {
                timeseg: {PeriodID:''},
                periods: {},
                tips: '',
                pd: {'上午': false, '下午': false},
                submitloading:false,
                showtable:false,
                bkfinaltext:'',
                user:[],
                admin:[],
                bkdate:[],
                institution:'',
                schbranchName:''
            }
        },
        mounted() {
            this.admin=JSON.parse(foowwLocalStorage.get('admin'));
            this.user=JSON.parse(sessionStorage.getItem('user'));
            this.bkdate=JSON.parse(sessionStorage.getItem('bkdate'));
            this.institution=sessionStorage.getItem('institution');
             this.schbranchName=this.institution === '1' ? '东环分院' : '西环分院'
            console.log( this.bkdate);
            if(this.admin==null || this.user==null){
                this.$alert('登录失效，请重新登录！', '错误', {
                         confirmButtonText: '确定',
                         callback: action => {
                         this.$router.push('/YBLogin');
                          }
                         });
                return;     
                }
           this.$http.post(restbase2() + "booking/WSOnline.asmx/GetBranchPeriodData3", {
                BranchID: this.institution,
                dateFrom:this.bkdate.date,
                branchName:this.schbranchName
            }).then((response) => {
                console.log(response.body.d);
                this.periods = JSON.parse(response.body.d);
            }, (response) => {
                console.log(response);
            }).catch((response) => {
                console.log(response);
            });
        },
        methods: {
       
            
            
             bookQuestion(order){
            this.idnumber=this.user.PaperValue;
            this.phone=this.user.phone;
            this.date=this.bkdate.date;
            if(this.idnumber.length<=0 || this.phone.length<=0||this.admin==null){
               this.$alert('该客户信息不足，或登录已过期', '温馨提示', {
                          confirmButtonText: '确定',
                            callback: action => {
                                this.$router.push('/YBLogin');
                             }
                          });
                }
             const h = this.$createElement
            this.$confirm('提示', {
                        title: '提示',
                         center: true,
                        message: h('div', [
                        h('p','预约人：'+this.user.name),
                        h('p','预约分院:'+ this.schbranchName),
                        h('p','预约时间：'+this.date+' '+this.timeseg.PeriodName),
                        h('p','确定预约吗？'),
                        ]),
                       confirmButtonText: '同意并继续',
                       cancelButtonText: '取消'
                        }).then(() => {
                        this.yuyue();
                       }).catch(()=>({

                       }))
          },
          yuyue(){
            const loading = this.$loading({
          lock: true,
          text: '操作中，请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
                 this.$http.post(restbase2() + "booking/WSOnline.asmx/RequestAppointment2", {
                    paperValue: this.user.PaperValue,
                    phone: this.user.phone,
                     date: this.bkdate.date,
                    BranchID: this.institution,
                    MoonID: "1",
                    PeriodID: this.timeseg.PeriodID,
                    source:"友邦客服预约"+this.admin.CnName
                }).then((response) => {
                    this.submitloading = false;
                    let d = JSON.parse(response.body.d);
                    loading.close();
                    if (d.status.code === 0) {
                         this.$alert('您的预约已成功', '温馨提示', {
                          confirmButtonText: '确定',
                           center: true,
                            callback: action => {
                                sessionStorage.removeItem("user");
                                sessionStorage.removeItem("bkdate");
                                sessionStorage.removeItem("institution");
                                this.$router.push('YBMember');
                             }
                          });
                    } else if (d.status.code > 10000) {
                        this.tips = d.status.description;
                    } else {
                        this.$message.error(d.status.description);
                        this.tips =  d.status.description;//'很抱歉，预约未成功。请点击右侧按钮留言或致电400 007 3939咨询。';
                   
                    }
                }, (response) => {
                    this.submitloading = false;
                    this.tips = "出错了，请检查网络连接";
                }).catch((response) => {
                    this.submitloading = false;
                    this.tips = "抱歉，出错了";
                });
          },
          userlist(){
          this.$confirm('您确定放弃当前用户重新选择吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
           center: true,
          type: 'warning'
        }).then(() => {
                        //清空前一个人的定制数据
                        sessionStorage.removeItem("user");
                        
                                sessionStorage.removeItem("bkdate");
                                sessionStorage.removeItem("institution");
                        this.$router.push('YBMember');
        })
          }
        }
    }
</script>

<style>
    .bs1title {
        position: relative;
        height: 50px;
        top: -98px;
        background-color: rgba(100, 149, 237, 0.5);
        font-size: 1.3em;
        color: white;
        padding-left: 20px;
        padding-top: 10px;
    }

    .bs1frame {
        height: 275px;
        border: 1px solid #ccc;
        border-radius: 2px;
        padding: 24px;
        background-color: #f7f7f7;
    }

    .bs1static {
        height: 62px;
        padding-top: 12px;
        padding-left: 24px;
        border: 1px solid #ddd;
        border-radius: 5px;
        color: #555;
        background-color: white;
        box-shadow: 1px 1px 1px #888;
    }

    .bs1input {
        padding-top: 36px;
        padding-left: 0px;
        width: 400px;
    }

    .bs1label {
        color: #666;
        margin-right:8px;
    }
</style>

<style>
    .rptframe {
		position:relative;
		width:90%;
		border:1px solid #ddd;
		border-radius:8px;
        box-shadow: 1px 1px 1px #888;
		text-align:center;
		margin:4px auto;
		background-color:white;
	}
    .tbl {
		width:90%;
		border:1px solid #ddd;
		border-radius:8px;
        box-shadow: 1px 1px 1px #888;
		margin:6px auto;
	}
</style>